<mat-tab-group [dynamicHeight]="true" [color]="settings.get('vebto.auth.color')">
    <mat-tab label="Bank Card" *ngIf="settings.get('billing.stripe.enable')">
        <credit-card-form (created)="subscribeOnStripe()" [submitButtonText]="submitText" [showOrderSummary]="true"></credit-card-form>
    </mat-tab>
    <mat-tab label="Paypal" [disabled]="disablePaypalTab" *ngIf="settings.get('billing.paypal.enable')">
        <div class="paypal-tab">
            <p class="info" trans>After clicking the button below, you will be redirected to paypal.com to approve the subscription.</p>
            <order-summary></order-summary>
            <button mat-raised-button color="primary" (click)="subscribeOnPaypal()" [disabled]="_loading">{{submitText}}</button>
        </div>
    </mat-tab>
</mat-tab-group>